ui-cms-faq-entry {
  display: block;

  .ui-cms-faq-entry__answer {
    margin-top: $sd-spacing-0;

    p {
      margin: $sd-spacing-0;
    }

    & > *:not(:first-child) {
      margin-top: $sd-spacing-3;
    }
  }

  .sd-headline + .ui-cms-faq-entry__answer {
    margin-top: $sd-spacing-4;
  }

  ui-link-list {
    margin-top: $sd-spacing-5;
  }

  ui-cms-rating {
    margin-top: $sd-spacing-8;
  }
}
